import {Box} from '@mui/material';
import {GetStaticPropsContext} from 'next';
import ErrorPage from 'next/error';
import {useRouter} from 'next/router';
import {useEffect} from 'react';
import {BlockRenderer} from '~/components/renderer/block-renderer';
import * as Types from '../../graphql/types';
import {getPageData} from '../[[...slug]]/index.page';
import {REVALIDATE_TIME} from '~/constants';
import smoothscroll from 'smoothscroll-polyfill';
import {handleConvertToLocaleContentful} from '~/utils';
import {LIST_ID_GAME_OUR_PICK} from '~/constants';
import getListGameForNav from '~/components/wrapper/organisms/navigation-bar/get-list-game';
import {getLitGameByIdBlock} from '~/components/wrapper/organisms/navigation-bar/get-list-game-by-id';

type PageGetNewsExt = {
  listTags: Types.TagsCollection;
  listTagsColor: any;
  data: any;
  dataWhatOn: Types.NewsCollection;
  getListTipsAndTricks: Types.NewsCollection;
  locale: string;
};

const AboutUs = (props: PageGetNewsExt) => {
  const {data} = props;
  const page = data?.pageCollection?.items[0];
  const router = useRouter();
  const id = router?.query?.id || '';

  useEffect(() => {
    let timeOut: any = null;
    if (typeof window !== 'undefined' && id) {
      smoothscroll.polyfill();

      timeOut = setTimeout(() => {
        const content = document.getElementById(id as string);
        if (content) {
          content.scrollIntoView();
        }
      }, 1000);
    }
    return () => {
      window.clearTimeout(timeOut);
    };
  }, [id]);

  if (!page) {
    return <ErrorPage statusCode={404} />;
  }

  let sectionMasthead = {};
  let sectionCEOMessage = {};
  let sectionLocaleUs = {};
  let sectionJobOpportunity = {};

  page.sectionCollection?.items.map((section: any, idx: number) => {
    if (section.blocksCollection.items[0].type === 'Masthead') {
      sectionMasthead = {
        ...section,
        blocksCollection: {
          ...section.blocksCollection,
          items: [
            {
              ...section.blocksCollection.items[0],
              __typename: 'MastheadImage',
            },
          ],
        },
      };
    }
    if (section.blocksCollection.items[0].type === 'CardMessage') {
      sectionCEOMessage = {
        ...section,
        blocksCollection: {
          ...section.blocksCollection,
          items: [
            {
              ...section.blocksCollection.items[0],
              __typename: 'MessageCard',
            },
          ],
        },
      };
    }
    if (section.blocksCollection.items[0].type === 'LocateUs') {
      sectionLocaleUs = {
        ...section,
        blocksCollection: {
          ...section.blocksCollection,
          items: [
            {
              ...section.blocksCollection.items[0],
              __typename: 'LocateUs',
            },
          ],
        },
      };
    }
    if (section.blocksCollection.items[0].type === 'JobOpportunity') {
      sectionJobOpportunity = {
        ...section,
        blocksCollection: {
          ...section.blocksCollection,
          items: [
            {
              ...section.blocksCollection.items[0],
              __typename: 'JobOpportunity',
            },
          ],
        },
      };
    }
  });

  // const subscribe = {
  //   __typename: 'SubscribePopup',
  // };
  const block: Array<any> = [
    page.seoStandard,
    sectionMasthead,
    sectionCEOMessage,
    sectionLocaleUs,
    sectionJobOpportunity,
  ].filter(block => !!block);
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
      }}
    >
      <BlockRenderer block={[...block]} slug={page?.slug ?? '/'} />
    </Box>
  );
};

export const getStaticProps = async (ctx: GetStaticPropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);
  const locale = handleConvertToLocaleContentful(ctx.locale as string);

  const [pageData, [navGameLatest, navOurPicks]] = await Promise.all([
    getPageData({slug: 'about-us', preview}, ctx as any),
    Promise.all([
      getListGameForNav(locale, 0, 6, {}, 'releaseDate_DESC'),
      getLitGameByIdBlock(LIST_ID_GAME_OUR_PICK[locale] ?? LIST_ID_GAME_OUR_PICK['en-sg'], locale),
    ]),
  ]);

  const navData = {
    gameLatest: navGameLatest?.items ?? [],
    ourPicks: navOurPicks ?? [],
  };
  const {data} = pageData;
  return {
    props: {
      data,
      locale: ctx?.locale,
      navData,
    },
    revalidate: REVALIDATE_TIME,
  };
};
export default AboutUs;
